import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { DEFAULT_PDF_NAME, DOCX_FILE_EXTENTION, DOWNLOAD_SUCCESS_TEXT, EXCEL_FILE_EXTENTION, EXCEL_XLS_FILE_EXTENTION, EXCEL_XLSB_FILE_EXTENTION, INVALID_USER_ACCESS_PAGE, PDF_DISPLAY_PREPARE_TEXT, PDF_EXTENSION, PPTX_EXTENTION } from 'src/app/core/model/constants';
import { GIRGridCellEvent, GirdColumn } from 'src/app/core/model/data-grid.model';
import { SOPService } from 'src/app/core/services/sop.service';
import { DownloadService } from 'src/app/core/services/download.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { NotifyService } from 'src/app/core/services/notify.service';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';

@Component({
  selector: 'app-sop',
  templateUrl: './sop.component.html',
  styleUrls: ['./sop.component.scss']
})
export class SOPComponent {
 public title = 'SOP'
  public elementsMeta: Object[] = []
  public elements: Object[] = []
  public columnList: GirdColumn[] = []
  public fileToDisplay: SafeUrl | undefined
  public sopInformationSub$: Subscription;
  public domSanitizer: DomSanitizer;
  public fileData: string | undefined;
  public fileName: string | undefined

  public sort: SortDescriptor[] = [];

  @ViewChild('downloadFile', { read: ViewContainerRef }) private viewRef!: ViewContainerRef
  
  constructor(private sopService: SOPService, private downloadService: DownloadService,
    private notifyService: NotifyService, private navigationService: NavigationService) {
  }

  ngOnInit() {
    this.getData();
  }

  public getData(){
    this.sopInformationSub$ = this.sopService.getSOPInformation({ fileName: this.fileName}).subscribe(
      x => {
        if (this.columnList.length == 0) {
          x.ColumnList.forEach(u => {
            this.columnList.push({
              id: u.id, columnTitle: u.columnName, isVisible: u.isVisible
              , isFilterable: u.isFilterable, filterCode: u.filterCode, columnField: u.columnDBName
            })
          })
        }
        this.elements = x.Datatable;
        this.elementsMeta = this.columnList.filter(u => u.isVisible == true)
      }
    )
  }

  public handleCellClickEvent(item: GIRGridCellEvent) {
    let linkData =  item?.cellDescription
    if(linkData?.length>0)
      if (linkData.includes(PDF_EXTENSION) || linkData.includes(EXCEL_FILE_EXTENTION) || linkData.includes(EXCEL_XLS_FILE_EXTENTION) || linkData.includes(EXCEL_XLSB_FILE_EXTENTION) || linkData.includes(DOCX_FILE_EXTENTION) || linkData.includes(PPTX_EXTENTION) )
        this.downloadDetailFile(item);
  }

  public downloadDetailFile(item: GIRGridCellEvent) {
     let fileName = item?.cellDescription ;   
      this.notifyService.info(PDF_DISPLAY_PREPARE_TEXT);
      this.downloadService.getSOPAttatchmentBinary(item.dataElementId, fileName)
      .subscribe(resp => { 
            this.notifyService.success(DOWNLOAD_SUCCESS_TEXT);
      },
        (error) => {
          if (error.status === 422) {
            this.navigationService.navigateToUrl(INVALID_USER_ACCESS_PAGE);
          }
        });
  }

  ngOnDestroy() {
    this.sopInformationSub$.unsubscribe();
  }

}
